import axios from 'axios';
import SiteConfig from './positiva';
import { getAccessToken } from '../utils/auth';
import repository from '../services/Repository';

const instance = axios.create({
    baseURL: SiteConfig.BASE_URL,
    timeout: 10000 
});


const getBussinessTurn = () => {
    return instance.get(`/business-turn/`, {
        headers: {
            'Authorization': `Token ${getAccessToken()}`,
        }
    })
}

const getRejectReasons = (action) => {
  return instance.get(`/quotation/action-reasons/?action=${action}`, {
    headers: {
        'Authorization': `Token ${getAccessToken()}`,
    }
})
}

const getAdditionalManagement = () => repository.private().get('/additional-management/');

export {
    getBussinessTurn,
    getAdditionalManagement,
    getRejectReasons
}